import React from 'react';
import { TuuiTheme } from 'tuui';
import { chatAgentTheme } from './tuuiChatAgentTheme';
import styles from './taboola-ultimate-ui.chat-agent.theme.module.scss';

export const ChatAgentThemeWrapper = ({ children }) => {
    return (
        <TuuiTheme theme={chatAgentTheme}>
            <div className={styles.chatAgent}>{children}</div>
        </TuuiTheme>
    );
};
